<template>
  <!-- drawer subject add -->
  <el-drawer
    :title="editorText + '学科'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <div style="height: calc(100% - 105px)">
      <el-form
        v-if="!editing"
        label-width="120px"
        :rules="rules"
        ref="form"
        :model="form"
        class="scroll"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="学科类型" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio :label="false">基础学科</el-radio>
                <el-radio :label="true">校本学科</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="学科名称" prop="name">
              <el-autocomplete
                v-model.trim="form.name"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="true"
                :maxlength="20"
                placeholder="请输入学科名称"
                style="width: 100%"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        v-else
        label-width="120px"
        :rules="form.mode === 1 ? editScoreRules : editLevelRules"
        ref="form"
        :model="form"
        class="scroll"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="学科类型" prop="type">
              <el-radio-group v-model="form.type" :disabled="editing">
                <el-radio :label="false">基础学科</el-radio>
                <el-radio :label="true">校本学科</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="学科名称" prop="name">
              <el-input
                v-model.trim="form.name"
                :maxlength="20"
                placeholder="请输入学科名称"
                :disabled="!identify.editAble"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="分数录入模式" prop="mode">
              <el-radio-group v-model="form.mode">
                <el-radio :label="1">分值</el-radio>
                <el-radio :label="2" :disabled="true">等第</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.mode === 1">
          <el-col :span="24">
            <el-form-item label="分值转换" prop="trans">
              <div class="grade">
                <span class="trans">A</span>
                <el-input v-model.trim="form.trans[0][0]" disabled></el-input
                >&nbsp;分以上
              </div>
              <div class="grade">
                <span class="trans">B</span>
                <el-input
                  v-model.trim="form.trans[1][0]"
                  @change="changeLowGood"
                ></el-input
                >&nbsp;-&nbsp;
                <el-input
                  v-model.trim="form.trans[1][1]"
                  @change="changeHighGood"
                ></el-input
                >&nbsp;分
              </div>
              <div class="grade">
                <span class="trans">C</span>
                <el-input v-model.trim="form.trans[2][0]" disabled></el-input
                >&nbsp;-&nbsp;
                <el-input v-model.trim="form.trans[2][1]" disabled></el-input
                >&nbsp;分
              </div>
              <div class="grade">
                <span class="trans">D</span>
                <el-input
                  v-model.trim="form.trans[3][0]"
                  @change="changeFail"
                ></el-input
                >&nbsp;分以下
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.mode === 1 && false">
          <el-col :span="24">
            <el-form-item label="学期分数计算" prop="term">
              <div class="grade">
                <span class="trans">平时</span>
                <el-input v-model.trim="form.term[0]"></el-input>&nbsp;%
              </div>
              <div class="grade" v-if="Number(this.identify.grade) >= 7">
                <span class="trans">期中</span>
                <el-input v-model.trim="form.term[1]"></el-input>&nbsp;%
              </div>
              <div class="grade">
                <span class="trans">期末</span>
                <el-input v-model.trim="form.term[2]"></el-input>&nbsp;%
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.mode === 1 && false">
          <el-col :span="24">
            <el-form-item label="学年分数计算" prop="year">
              <div class="grade">
                <span class="trans">上学期</span>
                <el-input v-model.trim="form.year[0]"></el-input>&nbsp;%
              </div>
              <div class="grade">
                <span class="trans">下学期</span>
                <el-input v-model.trim="form.year[1]"></el-input>&nbsp;%
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="submitting"
        @click="submitForm('form')"
        >确 定</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
import _ from 'lodash'
import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    var validateTrans = (rule, value, callback) => {
      if (value) {
        if (!value[1][0] || !value[1][1] || !value[3][0]) {
          this.submitting = false
          callback(new Error('分值不得为空'))
        } else {
          let number = /(^0\.5$)|(^[1-9][0-9]*(\.[05])?$)/
          if (!number.test(value[0][0]) || !number.test(value[1][0]) || !number.test(value[1][1]) || !number.test(value[2][0]) || !number.test(value[2][1]) || !number.test(value[3][0])) {
            this.submitting = false
            callback(new Error('分值必须为正整数或者.5结尾的正小数'))
          } else {
            if (Number(value[1][0]) >= Number(value[1][1]) || Number(value[2][0]) >= Number(value[2][1])) {
              this.submitting = false
              callback(new Error('分值设置错误'))
            } else {
              callback()
            }
          }
        }
      } else {
        callback()
      }
    }
    var validateTerm = (rule, value, callback) => {
      if (value.length !== 3) {
        this.submitting = false
        callback(new Error('比例不得为空'))
      } else if (value.length === 3) {
        let number = /^[1-9]\d*$/
        if (Number(this.identify.grade) >= 7) {
          if (!value[0] || !value[1] || !value[2]) {
            this.submitting = false
            callback(new Error('比例不得为空'))
          } else if (!number.test(value[0]) || !number.test(value[1]) || !number.test(value[2])) {
            this.submitting = false
            callback(new Error('比例必须为正整数'))
          } else if (Number(value[0]) + Number(value[1]) + Number(value[2]) !== 100) {
            this.submitting = false
            callback(new Error('比例之和必须为100'))
          } else {
            callback()
          }
        } else if (Number(this.identify.grade) < 7) {
          if (!value[0] || !value[2]) {
            this.submitting = false
            callback(new Error('比例不得为空'))
          } else if (!number.test(value[0]) || !number.test(value[2])) {
            this.submitting = false
            callback(new Error('比例必须为正整数'))
          } else if (Number(value[0]) + Number(value[2]) !== 100) {
            this.submitting = false
            callback(new Error('比例之和必须为100'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var validateYear = (rule, value, callback) => {
      if (value.length !== 2) {
        this.submitting = false
        callback(new Error('比例不得为空'))
      } else if (value.length === 2) {
        if (!value[0] || !value[1]) {
          this.submitting = false
          callback(new Error('比例不得为空'))
        } else {
          let number = /^[1-9]\d*$/
          if (!number.test(value[0]) || !number.test(value[1])) {
            this.submitting = false
            callback(new Error('比例必须为正整数'))
          } else {
            if (Number(value[0]) + Number(value[1]) !== 100) {
              this.submitting = false
              callback(new Error('比例之和必须为100'))
            } else {
              callback()
            }
          }
        }
      } else {
        callback()
      }
    }
    return {
      rules: {
        type: [
          { required: true, message: '请选择学科类型', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '学科名称不得为空', trigger: ['blur, change'] },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: ['blur, change'] }
        ]
      },
      editScoreRules: {
        type: [
          { required: true, message: '请选择学科类型', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '学科名称不得为空', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        mode: [
          { required: true, message: '请选择分数录入模式', trigger: ['blur', 'change'] }
        ],
        trans: [
          { required: true, message: '分值不得为空', trigger: 'blur' },
          { validator: validateTrans, trigger: 'blur' }
        ],
        term: [
          { required: true, message: '比例不得为空', trigger: 'blur' },
          { validator: validateTerm, trigger: 'blur' }
        ],
        year: [
          { required: true, message: '比例不得为空', trigger: 'blur' },
          { validator: validateYear, trigger: 'blur' }
        ]
      },
      editLevelRules: {
        type: [
          { required: true, message: '请选择学科类型', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '学科名称不得为空', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        mode: [
          { required: true, message: '请选择分数录入模式', trigger: ['blur', 'change'] }
        ]
      },
      submitting: false,
      form: { type: null, name: '', mode: 1, trans: [[], [], [], []], term: [], year: [] },
      editForm: {},
      isLastSuccessful: false,
      filterData: []
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.submitting = false
      this.filterData = []
      this.form.type = this.identify.subjectType || false
      this.form.name = this.identify.name || ''
      this.form.mode = this.identify.entryType || 1
      let scoreArr = []
      scoreArr.push(this.identify.excellent && this.identify.excellent.split() ? this.identify.excellent && this.identify.excellent.split() : [])
      scoreArr.push(this.identify.good && this.identify.good.split('-') ? this.identify.good && this.identify.good.split('-') : [])
      scoreArr.push(this.identify.qualified && this.identify.qualified.split('-') ? this.identify.qualified && this.identify.qualified.split('-') : [])
      scoreArr.push(this.identify.failed && this.identify.failed.split() ? this.identify.failed && this.identify.failed.split() : [])
      this.form.trans = scoreArr || [[], [], [], []]
      let termArr = []
      if (Number(this.identify.grade) >= 7) {
        termArr.push(this.identify.normal || 30)
        termArr.push(this.identify.midterm || 30)
        termArr.push(this.identify.terminal || 40)
      } else {
        termArr.push(this.identify.normal || 40)
        termArr.push(0)
        termArr.push(this.identify.terminal || 60)
      }
      this.form.term = termArr || []
      let yearArr = []
      yearArr.push(this.identify.semesterOne || 40)
      yearArr.push(this.identify.semesterTwo || 60)
      this.form.year = yearArr || []
      setTimeout(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      }, 100)
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    changeLowGood (val) {
      let number = /(^0\.5$)|(^[1-9][0-9]*(\.[05])?$)/
      if (number.test(val)) {
        this.form.trans[2][1] = Number(val)
        this.$forceUpdate()
      }
    },

    changeHighGood (val) {
      let number = /(^0\.5$)|(^[1-9][0-9]*(\.[05])?$)/
      if (number.test(val)) {
        this.form.trans[0][0] = Number(val)
        this.$forceUpdate()
      }
    },

    changeFail (val) {
      let number = /(^0\.5$)|(^[1-9][0-9]*(\.[05])?$)/
      if (number.test(val)) {
        this.form.trans[2][0] = Number(val)
        this.$forceUpdate()
      }
    },

    querySearch (queryString, cb) {
      if (this.filterData.length > 0) {
        let arr = _.cloneDeep(this.filterData)
        let temp = _.filter(arr, (o) => { return o.name.indexOf(this.form.name) !== -1 })
        for (let index = 0; index < temp.length; index++) {
          let element = _.cloneDeep(temp[index])
          temp[index].name = element.value
          temp[index].value = element.name
        }
        cb(temp)
        return false
      }
      this.$xhrGet(`/acc/subjects`, { grade: this.identify.grade }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.filterData = _.cloneDeep(rs.data)
          let arr = _.cloneDeep(rs.data)
          let temp = _.filter(arr, (o) => { return o.name.indexOf(this.form.name) !== -1 })
          for (let index = 0; index < temp.length; index++) {
            let element = _.cloneDeep(temp[index])
            temp[index].name = element.value
            temp[index].value = element.name
          }
          cb(temp)
        }
      })
    },

    xhrUpdate () {
      // let midterm = 0
      // let terminal = 0
      // if (Number(this.identify.grade) >= 7) {
      //   midterm = this.form.mode === 1 ? (this.form.term[1] === this.identify.midterm ? null : this.form.term[1]) : ''
      //   terminal = this.form.mode === 1 ? (this.form.term[2] === this.identify.terminal ? null : this.form.term[2]) : ''
      // } else {
      //   terminal = this.form.mode === 1 ? (this.form.term[2] === this.identify.terminal ? null : this.form.term[2]) : ''
      // }
      let realFormData = {
        feature: this.form.type === this.identify.subjectType ? null : this.form.type,
        id: this.identify.recordModeId,
        name: this.form.name === this.identify.name ? null : this.form.name,
        entryType: this.form.mode,
        excellent: this.form.trans[0][0],
        good: this.form.trans[1][0] + '-' + this.form.trans[1][1],
        qualified: this.form.trans[2][0] + '-' + this.form.trans[2][1],
        failed: this.form.trans[3][0]
      }
      if (__.isObjectPropertiesAllNull(realFormData)) {
        this.submitting = false
        this.$message.error('请修改信息后提交')
        return
      }
      this.$xhrPut(`/acc/grade/subjects/${this.identify.id}`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'name_exists') {
            this.$message.error('学科名称已存在')
          }
        }
      })
    },

    xhrAdd () {
      let realFormData = {
        feature: this.form.type,
        name: this.form.name
      }
      this.$xhrPost(`/acc/grade/${this.identify.grade}/subjects`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'name_exists') {
            this.$message.error('学科名称已存在')
          }
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.submitting = false
          return false
        }
      })
    },

    change () {
      this.$refs.cascader.toggleDropDownVisible()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-div /deep/ .el-input {
  width: 100%;
}
.grade /deep/ .el-input {
  width: 80px;
}
.grade /deep/ .el-input__inner {
  text-align: center;
}
.trans {
  display: inline-block;
  width: 60px;
}
.grade {
  margin-left: 10px;
  margin-bottom: 10px;
}
.form-div {
  margin-left: 10px;
  margin-bottom: 10px;
}
/deep/ .el-form {
  height: 100%;
  overflow: scroll;
}
/deep/ .el-drawer__body {
  overflow-y: scroll;
}
/deep/ .el-drawer__body::-webkit-scrollbar {
  display: none !important;
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/SubjectEditor.vue